import { Component, ContextType, ReactNode } from 'react';
import { TableContext } from '.';
type BoundaryProps = {
  children: ReactNode;
};
type BoundaryState = {
  initialLoadComplete: boolean;
  shouldTryResettingConfig: boolean;
};
export class SavedConfigErrorBoundary extends Component<BoundaryProps, BoundaryState> {
  constructor(props: BoundaryProps) {
    super(props);
    this.state = {
      initialLoadComplete: false,
      shouldTryResettingConfig: true
    };
  }
  static contextType = TableContext;
  context: ContextType<typeof TableContext>;
  componentDidCatch(error: Error) {
    if (this.state.shouldTryResettingConfig) {
      this.context.clearSavedConfig();
      this.setState({
        shouldTryResettingConfig: false
      });
    } else {
      throw error;
    }
  }
  componentDidUpdate(_prevProps: BoundaryProps, {
    initialLoadComplete: prevInitialLoadComplete
  }: BoundaryState) {
    // If initial table result load, don't do anything
    if (this.context.loading) return;

    // Initial result set is loaded; update state to that effect
    if (!this.state.initialLoadComplete) {
      return this.setState({
        initialLoadComplete: true
      });
    }

    /* Finally, let's set shouldTryResettingConfig to false, but not on the
       rerender that occurs from setting initialLoadComplete above.  This fn
       receives prevState as the 2nd param, so let's wait until a rerender
       has occurred AND the prevState intialLoadComplete was true, which
       should mean the table has "fully" loaded one time and a rerender
       was triggered after that
    */
    if (prevInitialLoadComplete && this.state.shouldTryResettingConfig) {
      this.setState({
        shouldTryResettingConfig: false
      });
    }
  }
  render() {
    return this.props.children;
  }
}